import { Component, Input } from '@angular/core';

import {
  PIN_CARD_VARIANTS,
  PIN_CARD_PADDING,
  PinCardVariant,
  PinCardPadding,
  pinCardClasses,
} from './pin-card.classes';

@Component({
    selector: 'pin-card',
    imports: [],
    template: `
    <div [class]="hostClasses">
      <div class="pin-card__header">
        <ng-content select="[pin-card-header]"></ng-content>
      </div>
      <div class="pin-card__body">
        <ng-content></ng-content>
      </div>
      <div class="pin-card__footer">
        <ng-content select="[pin-card-footer]"></ng-content>
      </div>
    </div>
  `
})
export class PinCardComponent {
  static readonly variants = PIN_CARD_VARIANTS;
  static readonly paddings = PIN_CARD_PADDING;

  @Input() variant: PinCardVariant = 'default';
  @Input() padding: PinCardPadding = 'md';

  get hostClasses(): string {
    return pinCardClasses({ variant: this.variant, padding: this.padding });
  }
}
